import reframe from 'reframe.js'

import './components/accordion'
import './components/form'
import './components/header-nav'
import './components/promo-banner'
import './components/scroll-animations'

document.addEventListener('DOMContentLoaded', () => {
  // Make iframes responsive
  reframe(document.querySelectorAll('.js-embed iframe'))
})
